require('../module/form');
require('./slider');
require('./animation');
require('./fr-img-box');
const App = require("./app");
const app = new App()
